import { render, staticRenderFns } from "./ApiTransfer.vue?vue&type=template&id=414c761e"
import script from "./ApiTransfer.vue?vue&type=script&lang=js"
export * from "./ApiTransfer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports